export const BUSINESSES_RESET_STATE = 'BUSINESSES_RESET_STATE';
export const BUSINESSES_CURRENT_ITEM = 'BUSINESSES_CURRENT_ITEM';

export const BUSINESSES_REQUEST_LOADING = 'BUSINESSES_REQUEST_LOADING';
export const BUSINESSES_REQUEST_SUCCESS = 'BUSINESSES_REQUEST_SUCCESS';
export const BUSINESSES_REQUEST_FAILED = 'BUSINESSES_REQUEST_FAILED';

export const BUSINESSES_CURRENT_ACTION = 'BUSINESSES_CURRENT_ACTION';
export const BUSINESSES_RESET_ACTION = 'BUSINESSES_RESET_ACTION';